import React from "react";
import * as source from 'ol/source';
import Feature from 'ol/Feature';
import * as geom from 'ol/geom';
import * as style from 'ol/style';
import * as proj from 'ol/proj';
import {  v4 as uuid } from 'uuid';
import drawState, {doNotAutochangeState}  from '../enums/drawState';
import Map from "../mapComponent/map";
import Layers from "../mapComponent/layers";
import TileLayer from "../mapComponent/tileLayer";
import VectorLayer  from "../mapComponent/vectorLayer";
import Interaction from "../mapComponent/interaction";
import pointType from "../enums/pointType";
import * as ContextMenu from 'ol-contextmenu';
import  'ol-contextmenu/dist/ol-contextmenu.min.css';
import Cookies from 'universal-cookie';

class InputMap1 extends React.Component {
  constructor(props) {
    super(props);

    this.state ={
      drawState: props.drawState,
    };

    this.drawStateHandler = props.drawStateHandler;
    this.drawScenario = props.drawScenario;
    this.removeScenario = props.removeScenario;
    this.getFeatureIdBystate = props.getFeatureIdBystate;
    this.getPreventUnorientedPoint = props.getPreventUnorientedPoint;
    this.linesBetweenPoints = props.linesBetweenPoints;
    this.props = props;
    this.drawSource = new source.Vector();
    this.displaySource = new source.Vector();
    this.displayLineSource = new source.Vector();
    this.addFeatureKey = undefined;
    this.init = true;
    //this.childRef = createRef();
    this.hadDrawnItems = this.hasDrawnItems(props);
    this.zoom = this.hadDrawnItems? undefined: this.tryGetLastZoom();
    this.maxDrawZoom = props.maxDrawZoom;
    this.map = null;
    this.start = props.start;
    this.end = props.end;
    this.points = props.points;
    this.onZoomChanged = props.onZoomChanged;
    this.removeMarkerItem = {
      text: 'Remove this Feature',
      classname: 'marker',
      callback: this.removeItem.bind(this)
    };
    this.noActionitem = {
      text: 'No action',
      classname: 'marker'
    };
    this.contextMenuItems = [
      {
        text: 'No actions',
        classname: 'bold',
        //icon: centerIcon,
        callback: null
      }
    ];
    this.contextmenu = null;
    this.lastUserLocationSet = false;
    if (this.state.drawState !== drawState.NONE) {    
      this.addFeatureKey = this.drawSource.on("addfeature", (e) => this.addFeature(e));
      this.beforeFeatureAddedKey = this.drawSource.on("add ", (e) => this.beforeFeatureAdded(e));
    }
  }

  componentDidMount() {
    this.setLocationFromBrowserIfNeeded();
  }

  componentWillReceiveProps(nextProps) {
    //if map was cleared
    if (this.hadDrawnItems && this.hasNoDrawnItems(nextProps)) {
        this.setState({ drawState: drawState.START });
        this.clear_inputs();
        if (!this.addFeatureKey)
        this.addFeatureKey  = this.drawSource.on("addfeature", (e) => this.addFeature(e));
        if (!this.beforeFeatureAddedKey)
        this.beforeFeatureAddedKey = this.drawSource.on("add ", (e) => this.beforeFeatureAddedKey(e));    
        this.hadDrawnItems = false;  
    }

    //nastaveni draw source pokud ma byt a neni
    if (nextProps.drawState !== drawState.NONE) {
      if (!this.addFeatureKey)
        this.addFeatureKey = this.drawSource.on("addfeature", (e) => this.addFeature(e));
    }
    //actualize draw state
    if (nextProps.drawState !== this.state.drawState) {
      this.setState({drawState: nextProps.drawState});
    }

    //set features
    this.start = nextProps.start;
    this.end = nextProps.end;
    this.points = nextProps.points;
    
    //redraw lines between points
    if (this.linesBetweenPoints)
      this.redrawLinesBetweenPonts();

    this.hasDrawItems = this.hasDrawnItems(nextProps);
  }

  hasDrawnItems(props) {
    return props.start || props.end || props.areaPolygon 
    || (props.points && props.points.length > 0) 
    || (props.polygons && props.polygons.length > 0);
  }

  hasNoDrawnItems(nextProps) {
    return !nextProps.start && !nextProps.end && !nextProps.areaPolygon 
    && (!nextProps.points || nextProps.points.length === 0) 
    && (!nextProps.polygons || nextProps.polygons.length === 0);
  }

  render() {
    let location = this.getLocation() ?? [-10771353.18, 3810003.67];

    let mapCenter = undefined;
    let zoom = this.zoom;
    if (this.init) {
      mapCenter = location;
      zoom = this.zoom ? this.zoom: 8
      this.init = false;
    }

      return <>
        <Map name="Map" center={mapCenter} projection={'EPSG:3857'} zoom={zoom} onSetZoom ={this.onSetZoom.bind(this)} /*ref={this.childRef} */onSetMap = {this.onSetMap.bind(this)} activeTool={this.state.drawState}>
          {this.isInDrawPointState() && <Interaction state = {this.state.drawState } drawSource = {this.drawSource}/>}
          {this.isInDrawPolygonState() && <Interaction state = {this.state.drawState } drawSource = {this.drawSource} deletePreviousPolygonCallback = {this.deletePreviousPolygonCallback.bind(this)}/>}
          <Layers>
            <TileLayer name="TileLayer" source={new source.OSM()} zIndex={0} />
            <VectorLayer name="Layer1"  source={this.drawSource} />
            <VectorLayer name="Layer2"  source={this.displayLineSource} style = {this.displayLineStyleFunction.bind(this)}/>
            <VectorLayer name="Layer3"  source={this.displaySource} style = {this.displayStyleFunction.bind(this)} />
          </Layers>
        </Map>
      </>;
  }

  setLastZoom(zoom) {
    const cookies = new Cookies();
    cookies.set('lastZoom', JSON.stringify(zoom), { path: '/', sameSite: true });
  }

  tryGetLastZoom() {
    const cookies = new Cookies();
    let lastZoom = cookies.get('lastZoom');
    if (!isNaN(lastZoom)) {
      return parseFloat(lastZoom);
    }    
    return undefined;
  }

  setLocationFromBrowserIfNeeded() {
    if (this.getLocation())
      return;
    navigator.geolocation.getCurrentPosition(this.setCurrentPosition.bind(this))
  }

  setCurrentPosition(position) {
    const cookies = new Cookies();
    if (cookies.get('location'))
      return;

    let location = {lon: position.coords.longitude,lat: position.coords.latitude}
    cookies.set('location', JSON.stringify(location), { path: '/', sameSite: true });
    //console.log(cookies.get('location'));
    if (this.map)
      this.map.getView().setCenter(proj.transform([location.lon, location.lat], 'EPSG:4326', 'EPSG:3857'));
    //else console.log('no map');
  }

  setLastUserLocation(lat, lon) {
    if (this.state.drawState !== drawState.START || this.lastUserLocationSet)
      return;

    let lotlan = proj.transform([lon, lat], 'EPSG:3857', 'EPSG:4326')
    let location =  {lon: lotlan[0],lat: lotlan[1]}
    const cookies = new Cookies();
    cookies.set('location', JSON.stringify(location), { path: '/', sameSite: true });
    this.lastUserLocationSet = true;       
  }

  getLocation() {
    const cookies = new Cookies();
    let locationString = cookies.get('location');
    if (locationString) {
      try {
        let location = JSON.parse(locationString);
        return [location.lon, location.lat]
      }
      catch(e) {}
    }
    return undefined;
  }

  isInDrawPointState() {
      return this.state.drawState === drawState.START || this.state.drawState === drawState.END || this.state.drawState === drawState.POINTS;
  }

  isInDrawPolygonState() {
    return this.state.drawState === drawState.AREAPOLYGON || this.state.drawState === drawState.OBSTACLES;
  }

  onSetZoom(val, initialSet) {
    if (initialSet && this.zoom) {
      if (this.onZoomChanged) 
        this.onZoomChanged(val);
      return;
    }

    if (this.zoom === val)
      return;

    this.zoom = val;
    if (this.onZoomChanged) {
      this.onZoomChanged(val);
      this.setLastZoom(val);
    }
  }

  onSetMap(map) {
    this.map = map;
    let extent = this.draw_inputs(this.props.start, this.props.end, this.props.areaPolygon, this.props.points, this.props.polygons);
    //call after render!!
    if (extent) {
      setTimeout(() => {
        let view = map.getView();
        view.fit(extent, map.getSize());
        let newZoom =  view.getZoom() - 1 < this.maxDrawZoom ? this.maxDrawZoom: view.getZoom() - 1
        view.setZoom(
          newZoom
        )
      }, 10);
    }
    const cookies = new Cookies();
    let location = cookies.get('location'); // Pacman
    if (location)
      this.map.getView().setCenter(proj.transform([location.lon, location.lat], 'EPSG:4326', 'EPSG:3857'));    

    this.contextmenu = new ContextMenu({
      width: 180
    });

    this.map.addControl(this.contextmenu);
    this.contextmenu.on('open', this.onContext.bind(this));
  }

  removeItem(obj) {
    let featureId = obj?.data?.feature?.id_;
    if (!featureId)
      return;

    let feature = this.displaySource.getFeatureById(featureId);
    if (feature) {
        this.displaySource.removeFeature(feature);
        this.props.store.dispatch(this.removeScenario.get(feature.drawStateContext)(featureId));
        if (this.linesBetweenPoints)
          this.redrawLinesBetweenPonts();
        return;
    }

    feature = this.drawSource.getFeatureById(featureId);
    if (feature) {
        this.drawSource.removeFeature(feature);
        this.props.store.dispatch(this.removeScenario.get(feature.drawStateContext)(featureId));
    }
  }

  onContext (evt) {
    let feature =	this.map.forEachFeatureAtPixel(evt.pixel, ft => ft);
      this.contextmenu.clear();
      if (feature && feature.id_) {
        let removeMakerItemCopy = (({text, classame, callback}) => ({text, classame, callback}))(this.removeMarkerItem);
        removeMakerItemCopy.data = { feature: feature };
        this.contextmenu.extend(this.contextmenu.getDefaultItems());
        this.contextmenu.push(removeMakerItemCopy);
      } else {
        this.contextmenu.extend(this.contextmenu.getDefaultItems());
      }
  }

  draw_inputs(start, end, areaPolygon, points, polygons) {
    if (areaPolygon)
      this.draw_input_polygon(areaPolygon) ;
    if (start)
      this.draw_input_point(start);
    if (end)
      this.draw_input_point(end);
    if (points) {
      for (let point of points) {
        this.draw_input_point(point);        
      }
      if (this.linesBetweenPoints)
        this.redrawLinesBetweenPonts();
    }
    if (polygons) {
      for (let polygon of polygons) {
        this.draw_input_polygon([polygon]);        
      }
    }
    let extent = this.get_map_position();
   // this.childRef?.current?.setPosition(this.get_map_position());
    return extent;
  }

  get_map_position() {

    let polygons = this.drawSource.getFeatures();
    if (polygons.length > 0) {
      return this.drawSource.getExtent();

    }
    else {
      let points = this.displaySource.getFeatures();
      if (points.length > 0) {
        return this.displaySource.getExtent();
      }
    }
    return null;
  }

  draw_input_point(point) {
    if (!point)
      return;
    let rotation = Math.atan2(point.VectorY, point.VectorX);

    let feature = new Feature({
        geometry: new geom.Point([point.Lon, point.Lat]),
        rotation: rotation
    });

    feature.setId(point.Id);
    feature.isInput = true;
    feature.pointType = point.PointType;
    feature.drawStateContext = point.DrawStateContext;

    this.displaySource.addFeature(feature);
  }

  draw_input_polygon(areaPolygon) {
    if (!areaPolygon)
      return;
    let feature = new Feature({
        geometry: new geom.Polygon(areaPolygon[0].coordinates)
    });
    feature.setId(areaPolygon[0].Id);
    feature.drawStateContext = areaPolygon[0].drawStateContext;
    feature.isInput = true;
    this.set_polygon_style(feature);
    this.drawSource.addFeature(feature);     
  }

  set_polygon_style(feature) {
    if (feature.drawStateContext === drawState.AREAPOLYGON) {
      feature.setStyle(
       new style.Style({
         stroke: new style.Stroke({
           color: [52, 168, 158, 255],
           width: 2,
         }),
         fill: new style.Fill({
           color: [190, 235, 214, 0.3]
         }),
         zIndex: 0
       }));
   }
   else {
     feature.setStyle(
       new style.Style({
         stroke: new style.Stroke({
           color: [86, 92, 94, 255],
           width: 2,
         }),
         fill: new style.Fill({
           color: [164, 163, 153, 0.3]
         }),
         zIndex: 100
       }));
   }
  }

  clear_inputs() {
    this.displaySource.clear();
    this.drawSource.clear();
    if (this.props.afterFeatureAdded)
      this.props.afterFeatureAdded();
    if (!this.addFeatureKey) {
      this.drawSource.on("addfeature", (e) => this.addFeature(e));
    }
  }

  beforefeatureadded (e) {
  }

  deletePreviousPolygonCallback(){
    this.removeOldPolygon(this.state.drawState);
  }

  addFeature(e) {
    if (this.state.drawState === drawState.NONE)
      return;

    this.hadDrawnItems = true;

    let coordinates = e.feature.getGeometry().flatCoordinates;
    if ((this.state.drawState === drawState.AREAPOLYGON || this.state.drawState === drawState.OBSTACLES) && coordinates.length > 0) {
      if (e?.feature && !e.feature.isInput) {

        if (this.state.drawState === drawState.AREAPOLYGON) {
           e.feature.setStyle(
            new style.Style({
              stroke: new style.Stroke({
                color: [52, 168, 158, 255],
                width: 2,
              }),
              fill: new style.Fill({
                color: [190, 235, 214, 0.3]
              }),              
            }));
            e.feature.zIndex = 0;
        }
        else {
          e.feature.setStyle(
            new style.Style({
              stroke: new style.Stroke({
                color: [86, 92, 94, 255],
                width: 2,
              }),
              fill: new style.Fill({
                color: [164, 163, 153, 0.3]
              })
            }));
            e.feature.zIndex = 100;
        }
        
        let id = uuid();
        e.feature.setId(id);
        e.feature.drawStateContext = this.state.drawState;
        this.props.store.dispatch(this.drawScenario.get(this.state.drawState)([{Id: id, drawStateContext: this.state.drawState , coordinates: e.feature.getGeometry().getCoordinates()}]));
      }
    }
    else if (coordinates.length === 4) {
        // Line string
        let diff_x = coordinates[2] - coordinates[0];
        let diff_y = coordinates[3] - coordinates[1];
        let ext_x = coordinates[0] - diff_x;
        let ext_y = coordinates[1] - diff_y;
        // Compute rotation
        let dx = coordinates[2] - ext_x;
        let dy = coordinates[3] - ext_y;
        let rotation = Math.atan2(dy, dx);

        let feature = new Feature({
            geometry: new geom.Point([coordinates[0], coordinates[1]]),
            rotation: rotation,
        });

        let unorientedPoint = this.getPreventUnorientedPoint && !this.getPreventUnorientedPoint(this.state.drawState) && diff_x + diff_y === 0 ;

        if (unorientedPoint) {
          diff_x = 0;
          diff_y = 0;
        }

        switch(this.state.drawState) {
          case drawState.START:
            feature.pointType = pointType.START;
            break;
          case drawState.END:
            feature.pointType = pointType.END;
            break;
          case drawState.POINTS:
            feature.pointType = pointType.TRANSIT; //getPointType
            break;
          //TODO better default
          default:
            feature.pointType = pointType.START;       
        }

        feature.drawStateContext = this.state.drawState;

        if (unorientedPoint) {
          feature.pointType = feature.pointType | pointType.UNORIENTED;
        }

        let id = uuid();
        feature.setId(id);
        this.removeOldPoint(this.state.drawState) 
        this.displaySource.addFeature(feature);
        this.drawSource.removeFeature(e.feature);
        if (e?.feature && !e.feature.isInput)
          this.props.store.dispatch(this.drawScenario.get(this.state.drawState)({
              Lat: coordinates[1],
              Lon: coordinates[0],
              VectorX: diff_x,
              VectorY: diff_y,
              Id: id,
              PointType: feature.pointType,
              DrawStateContext: feature.drawStateContext
            }));

        this.setLastUserLocation(coordinates[1], coordinates[0]);
    }

    this.props.afterFeatureAdded();
  }
  
  redrawLinesBetweenPonts() {
    this.displayLineSource.clear();
    let lastPoint;
    let allPoints = [...[this.start],...this.points,...[this.end]];
    for (let point of allPoints) {
      if (!point || !lastPoint) {
        lastPoint = point;
        continue;
      }
      let points = [
        [lastPoint.Lon, lastPoint.Lat], [point.Lon, point.Lat]
      ];
      let feature = new Feature({
        geometry: new geom.LineString(points),
      });
      this.displayLineSource.addFeature(feature);
      
      lastPoint = point;
    }
  }

  removeOldPoint(state) {
    let myId = this.getFeatureIdBystate(state)
    if (!myId)
      return;

    let feature = this.displaySource.getFeatureById(myId);
    if (feature)
        this.displaySource.removeFeature(feature);
  }

  removeOldPolygon(state) {
    let myId = this.getFeatureIdBystate(state)
    if (!myId) return;

    let feature = this.drawSource.getFeatureById(myId);
    if (feature)
        this.drawSource.removeFeature(feature);
  }

  setNewStateFromDrawScenario() {
    if (doNotAutochangeState(this.state.drawState))
      return;

    let pos = 0;
    let keys =[ ...this.drawScenario.keys() ];

    for (let key of keys) {
      if (key === this.state.drawState)
        break;
      pos++;
    }

    if (keys.length > pos + 1) {
      this.setState({drawState: keys[pos + 1], clear: false});
      //todo remove first param
      this.drawStateHandler(keys[pos + 1]);
    }
  }

  displayStyleFunction(feature) {
      let styles = [];
      //feature state
      if (feature.values_.rotation !== undefined && feature.values_.rotation !== null) {
          styles.push(
              new style.Style({
                  image: new style.Icon({
                      src: this.getIconByPointType(feature.pointType),
                      rotateWithView: true,
                      rotation: -feature.values_.rotation
                  }),
              })
          );
      }

      return styles;
  }

  displayLineStyleFunction(feature) {
    let styles = [];
        styles.push(
            new style.Style({
              stroke: new style.Stroke({
                color: [250, 166, 34, 255],
                width: 5,
                lineDash: [10],
                lineDashOffset: 30
              })
            })
        );
    return styles;
  }

 drawStyleFunction(feature) {
    let styles = [];
    //feature state
    if (feature.values_.rotation !== undefined && feature.values_.rotation !== null) {
        styles.push(
            new style.Style({
                image: new style.Icon({
                    src: this.getIconByPointType(feature.pointType),
                    rotateWithView: true,
                    rotation: -feature.values_.rotation
                }),
            })
        );
    }

    return styles;
  }

  getIconByPointType(myPointType) {
    switch(myPointType) {
      case pointType.START | pointType.UNORIENTED: return '/start.png';
      case pointType.START: return '/start-oriented.png';
      case pointType.END | pointType.UNORIENTED: return '/end.png';
      case pointType.END: return '/end-oriented.png';
      case pointType.UNORIENTED | pointType.TRANSIT: return '/point.png';
      case pointType.TRANSIT: return '/point-oriented.png';
      default: return '/point-oriented.png';  
    }
  }
}

export default InputMap1;